/* unplugin-vue-components disabled */import { render } from "./ChangeWorker.vue?vue&type=template&id=6c9ba945"
import script from "./ChangeWorker.vue?vue&type=script&lang=js"
export * from "./ChangeWorker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__